import React from 'react';
import { motion } from 'framer-motion';
import './Collection3D.css';

/*
 * ==============================================
 * HOW TO EDIT (via Claude chat):
 * ==============================================
 * "Add a 3D collection image with url https://... and caption '...'"
 * "Update the 3D collection description"
 */

const items = [
  // === ADD 3D COLLECTION ITEMS BELOW ===
  // {
  //   id: 1,
  //   src: '/images/3d/model1.jpg',
  //   title: '3D Model Name',
  //   description: 'Description of the piece',
  //   year: '2024',
  // },
  // === ADD 3D COLLECTION ITEMS ABOVE ===
];

function Collection3D() {
  return (
    <section className="collection3d section-padding" id="collection3d">
      <div className="container">
        <motion.div
          className="collection3d__header"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-100px' }}
          transition={{ duration: 0.8 }}
        >
          <span className="section-label">3D Collection</span>
          <h2 className="section-title">
            My 3D<br />
            <span className="text-gradient">collection gallery</span>
          </h2>
        </motion.div>

        {items.length > 0 ? (
          <div className="collection3d__grid">
            {items.map((item, i) => (
              <motion.div
                key={item.id}
                className="collection3d__card"
                initial={{ opacity: 0, y: 40, scale: 0.95 }}
                whileInView={{ opacity: 1, y: 0, scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.08 * i }}
                whileHover={{ y: -8, transition: { duration: 0.3 } }}
              >
                <div className="collection3d__card-image">
                  <img src={item.src} alt={item.title} loading="lazy" />
                </div>
                <div className="collection3d__card-info">
                  <h3>{item.title}</h3>
                  {item.description && <p>{item.description}</p>}
                  {item.year && <span className="collection3d__card-year">{item.year}</span>}
                </div>
              </motion.div>
            ))}
          </div>
        ) : (
          <motion.div
            className="collection3d__empty"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <div className="collection3d__empty-icon">🎲</div>
            <h3>No items yet</h3>
            <p>Tell Claude to add images of your 3D collection here!</p>
          </motion.div>
        )}
      </div>
    </section>
  );
}

export default Collection3D;
